export const ANONYMOUS_PAGE_VISIT_EVENT = 'anonymous_page_visit';
export const UNSUBSCRIBE_PAGE_EVENT = 'unsubscribe_page';
